module.exports = __webpack_public_path__ + "open-sans.3eb14f3838ada50e10f0.woff";


//////////////////
// WEBPACK FOOTER
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/assets/fonts/google/open-sans.woff
// module id = RfX1
// module chunks = 1